import { Abwesenheit } from '@/domain/mitarbeiter/features/rotationsplan/entities/Abwesenheit';
import { Interval } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/Interval';

export class KalenderAbwesenheit extends Interval {
  constructor({ abwesenheit }: { abwesenheit: Abwesenheit }) {
    super({ von: abwesenheit.von, bis: abwesenheit.bis });
    this.abwesenheit = abwesenheit;
  }

  abwesenheit: Abwesenheit;
}
